export default __webpack_public_path__ + "static/baranse-61ca70a06814c9670d1cee34066560ec.mp4";